import _sfc_main from "./component-library291.mjs";
import "./component-library292.mjs";
import normalizeComponent from "./component-library97.mjs";
var _sfc_render = function render() {
  var _vm = this, _c = _vm._self._c, _setup = _vm._self._setupProxy;
  return _c(_setup.LinkButton, _vm._b({ directives: [{ name: "on-clickaway", rawName: "v-on-clickaway", value: _setup.openable.onClickaway, expression: "openable.onClickaway" }], ref: "buttonElement", class: _setup.containerClass, attrs: { "tag": "button", "type": "button" }, on: { "click": _setup.click }, nativeOn: { "mouseover": function($event) {
    return _setup.mouseOver.apply(null, arguments);
  }, "mouseleave": function($event) {
    return _setup.mouseLeave.apply(null, arguments);
  }, "focus": function($event) {
    return _setup.onFocus.apply(null, arguments);
  }, "blur": function($event) {
    return _setup.onBlur.apply(null, arguments);
  } } }, "LinkButton", _vm.button, false), [_c("span", { ref: "tooltipElement", staticClass: "tooltip-container", class: `tooltip-container--${_setup.tooltipPosition}`, attrs: { "role": "tooltip", "aria-hidden": _vm.innerAriaHidden ? "true" : "false" } }, [_c("span", { domProps: { "innerHTML": _vm._s(_vm.text) } })]), _vm._t("default")], 2);
};
var _sfc_staticRenderFns = [];
var __component__ = /* @__PURE__ */ normalizeComponent(
  _sfc_main,
  _sfc_render,
  _sfc_staticRenderFns,
  false,
  null,
  "d514e19d",
  null,
  null
);
const Tooltip = __component__.exports;
export {
  Tooltip as default
};
